import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabaseClient.ts';

function Newsletter() {
  const [sectionData, setSectionData] = useState(null);

  useEffect(() => {
    const fetchSectionData = async () => {
      const { data, error } = await supabase
        .from('newsletter_section')
        .select('*')
        .limit(1)
        .single();

      if (!error) {
        setSectionData(data);
      }
    };
    fetchSectionData();
  }, []);

  return sectionData && (
    <div className="newsletter-area pb-110 " style={{marginTop:"100px",marginLeft:"190px"}}>
      <div className="container">
        <div className="row">
          <div className="col-12">
          <div className="newsletter-wrap">

  <img
    src="../img/images/mask.png"
    alt="Overlay"
    style={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      objectFit: "cover",
      borderRadius: "15px", // match the container
      zIndex: 1,
      pointerEvents: "none", // optional: allows clicks to pass through
    }}
  />
              <div className="newsletter-content">
                <h2 className="title" >{sectionData.title}</h2>
                <p><span>*</span> {sectionData.subtitle}</p>
              </div>
               <div className="newsletter-form">
            <form>
              <input type="email" placeholder="Entrez votre adresse e-mail..." />
              <button type="submit" className="btn">S'inscrire</button>
            </form>
          </div>
              {/* <div className="newsletter-shape">
                <img src={sectionData.image1_url} alt="" />
              </div> */}
              {/* <div className="newsletter-shape shape-two">
                <img src={sectionData.image2_url} alt="" />
              </div> */}

         
         
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Newsletter;
